const ApiLink = process.env.REACT_APP_SERVER_URL

export default ApiLink
